import { motion } from "framer-motion";
import { MaskedLines, Eyebrow } from "./Reveal";

export const PageHero = ({ eyebrow, lines, intro, testid }) => (
  <section className="relative bg-[#070F1E] grain pt-36 sm:pt-44 pb-16 sm:pb-24 overflow-hidden" data-testid={testid}>
    <div className="absolute -right-40 -top-40 h-[520px] w-[520px] rounded-full bg-[radial-gradient(circle,rgba(197,160,89,0.18),transparent_65%)]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}><Eyebrow dark>{eyebrow}</Eyebrow></motion.div>
      <h1 className="mt-8 font-display text-[#F4EEE3] text-5xl sm:text-7xl lg:text-[7.5rem] leading-[0.92] tracking-tight">
        <MaskedLines lines={lines} />
      </h1>
      {intro && (
        <motion.p initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7, duration: 0.9 }} className="mt-10 max-w-xl text-base sm:text-lg text-[#C9C3B6] leading-relaxed">
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
